// extracted by mini-css-extract-plugin
export default {"links":"LoginLink_links__mPUI4"};